var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnwish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27 6.69C24.49 4.18 20 3.25 16 7a8.13 8.13 0 0 0-7.65-2.25A7.49 7.49 0 0 0 3.05 10c-.73 2.73.2 5.65 2.55 8l8.79 8.78a2.27 2.27 0 0 0 3.22 0L26.4 18c4.11-4.06 3.19-8.72.6-11.31zm-1.31 10.65-8.79 8.79a1.29 1.29 0 0 1-1.8 0l-8.79-8.79c-2.13-2.13-2.94-4.63-2.29-7a6.41 6.41 0 0 1 6.21-4.8A7.7 7.7 0 0 1 15.64 8a.53.53 0 0 0 .36.15.51.51 0 0 0 .35-.15c3.63-3.63 7.7-2.86 10-.61s2.96 6.32-.66 9.95z",
    "data-name": "Layer 16",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnwish);
export default __webpack_public_path__ + "static/media/unwish.f19cb50b160beb20b72a67871f850986.svg";
export { ForwardRef as ReactComponent };